import { z } from "zod"

export const TravelersCheckLogSchema = z.object({
  id: z.number(),
  state_current: z.string().nullable(),
  state_next: z.string(),
  user_name: z.string(),
  agency_name: z.string(),
  created_at: z.string().nullable(),
  values: z.array(z.object({
    attribute: z.string(),
    old: z.string(),
    new: z.string(),
  })),
})

export const TravelersCheckSchema = z.object({
  id: z.number(),
  client_name: z.string().nullable(),
  issuing_file: z.number().nullable(),
  redeem_file: z.number().nullable(),
  valid_until: z.string().nullable(),
  value: z.number().nullable(),
  value_in_words: z.string().nullable(),
  issuing_agency_id: z.number(),
  issuing_agency_name: z.string(),
  redeem_agency_id: z.number().nullable(),
  redeem_agency_name: z.string().nullable(),
  claim_agency_id: z.number().nullable(),
  claim_agency_name: z.string().nullable(),
  allow_agency_id: z.number().nullable(),
  state: z.string(),
  issued_at: z.string().nullable(),
  redeem_at: z.string().nullable(),
  created_at: z.number().nullable(),
  updated_at: z.number().nullable(),
})

export const TravelersCheckDetailSchema = TravelersCheckSchema.extend({
  logs: z.array(TravelersCheckLogSchema).default([]),
})

export const TravelersCheckFormSchema = z.object({
  issuing_agency_id: z.number().min(1, "validation.issuingAgencyRequired"),
  client_name: z.string().optional().default(""),
  issuing_file: z.number().nullable().optional().default(null),
  redeem_file: z.number().nullable().optional().default(null),
  value: z.number().nullable().optional().default(null),
  value_in_words: z.string().optional().default(""),
  valid_until: z.string().nullable().optional().default(null),
  state: z.string().optional().default("created"),
})

export type TravelersCheck = z.infer<typeof TravelersCheckSchema>
export type TravelersCheckDetail = z.infer<typeof TravelersCheckDetailSchema>
export type TravelersCheckFormValues = z.infer<typeof TravelersCheckFormSchema>
export type TravelersCheckLog = z.infer<typeof TravelersCheckLogSchema>

export const STATE_MAP: Record<string, { label: string; color: string }> = {
  created: { label: "Criado", color: "gray" },
  issued: { label: "Emitido", color: "blue" },
  request_redeem: { label: "Pedido Rebate", color: "yellow" },
  reddem: { label: "Rebatido", color: "green" },
  deleted: { label: "Eliminado", color: "red" },
}
